interface PowerButtonProps {
  isOn: boolean;
  onToggle: () => void;
}

export default function PowerButton({ isOn, onToggle }: PowerButtonProps) {
  return (
    <div className="flex flex-col items-center gap-2">
      <button
        type="button"
        onClick={onToggle}
        aria-label={isOn ? "停止" : "起動"}
        className="group relative flex h-28 w-28 cursor-pointer items-center justify-center"
      >
        {isOn && <span className="animate-ping-slow absolute inset-0 rounded-full bg-primary-500/20" />}
        {isOn && <span className="animate-pulse-ring absolute -inset-2 rounded-full border border-primary-300/40" />}
        <span
          className={`relative flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br transition-all duration-200 ease-out active:scale-90 ${
            isOn ? "from-primary-500 to-primary-700" : "from-background-200 to-background-300"
          }`}
        >
          <i
            className={`${isOn ? "ri-stop-fill" : "ri-play-fill"} text-3xl transition-transform duration-200 group-active:scale-75 ${
              isOn ? "text-background-50" : "text-foreground-700"
            }`}
          />
        </span>
      </button>
      <span className="text-sm font-medium text-foreground-700">
        {isOn ? "動作中 · タップで停止" : "タップで起動"}
      </span>
    </div>
  );
}